import LocationSearchEventBus from "./event-bus";
import LocationSearchAnalytics from "./analytics";
import LocationSearchStore from "./store";
import Location from "./model";

import LocationSearchFilters from "./components/filters";
import LocationSearchSlider from "./components/slider";
import LocationSearchLineups from "./components/lineups";
import LocationSearchItems from "./components/items";

export default class LocationSearchModule {
  initialize() {
    const locationSearchElements = document.querySelectorAll(".location-search");

    locationSearchElements.forEach((locationSearchElement) => {
      const locationElements = locationSearchElement.querySelectorAll(".location-search-item");
      const locations = Array.from(locationElements).map((el) => new Location(el));
      
      const sliderElement = locationSearchElement.querySelector(".location-search-slider-container");
      const customMaxCapacity = parseInt(sliderElement?.dataset.maxRangeCapacity || 0, 10);

      const eventBus = new LocationSearchEventBus();
      const store = new LocationSearchStore(eventBus, locations, { 
        customMaxCapacity: customMaxCapacity 
      });
      
      const analytics = new LocationSearchAnalytics(store, locationSearchElement);
      store.setAnalytics(analytics);

      new LocationSearchFilters(locationSearchElement.querySelector(".location-search-filters"), store, eventBus);
      new LocationSearchSlider(sliderElement, store, eventBus);
      new LocationSearchLineups(locationSearchElement.querySelector(".location-search-lineups"), store, eventBus);
      new LocationSearchItems(locationSearchElement.querySelector(".location-search-items"), store, eventBus);
    });
  }
}